import { createFileRoute } from '@tanstack/react-router'
import ManageAccess from 'pages/manageAccess/ManageAccess'
import { z } from 'zod'

const manageAccessSearchSchema = z.object({
  mode: z.enum(['users', 'roles']).default('users'),
  organization: z.string().optional(),
})

export const Route = createFileRoute('/admin/access')({
  component: ManageAccess,
  validateSearch: manageAccessSearchSchema,
  staticData: {
    title: 'Manage Access',
  },
})
